import PropTypes from 'prop-types'
import styled from 'styled-components'
import { forwardRef } from 'react'

import { flexItemPropTypes, flexItemMixin } from '../utils'
import { getMargin, getPadding, marginPropTypes, paddingPropTypes } from '../../utils'

const StyledFlex = styled.div`
  box-sizing: border-box;
  display: ${({ display }) => (display === 'inline' ? 'inline-flex' : 'flex')};
  flex-direction: ${({ direction }) => direction};
  flex-wrap: ${({ wrap }) => wrap};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  gap: ${({ gap }) => gap};
  ${flexItemMixin};
  ${getMargin};
  ${getPadding};
`
const Flex = forwardRef(function Flex(
  {
    children,
    display = 'block',
    direction = 'row',
    wrap = 'nowrap',
    alignItems = 'normal',
    justifyContent = 'normal',
    gap = 'normal',
    ...rest
  },
  ref
) {
  return (
    <StyledFlex
      ref={ref}
      display={display}
      direction={direction}
      wrap={wrap}
      alignItems={alignItems}
      justifyContent={justifyContent}
      gap={gap}
      {...rest}>
      {children}
    </StyledFlex>
  )
})

Flex.propTypes = {
  ...marginPropTypes,
  ...paddingPropTypes,
  ...flexItemPropTypes,
  display: PropTypes.oneOf(['block', 'inline']),
  justifyContent: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  alignItems: PropTypes.string,
  gap: PropTypes.string
}

export { Flex }
